const HR_TICKETS_TABLE_READY = "hr-tickets-table-ready"
const SEARCH_TEXT_STATE = "hr-tickets-table-search-text-state"
const ROWS_PER_PAGE_STATE = "hr-tickets-table-rows-per-page-state"
const PAGINATION_STATE = "hr-tickets-table-pagination-state"

const HR_TICKETS_ID_FOR_ACTION = "hr-tickets-table-brand-id-for-action"

const ADD_EDIT_HR_TICKETS_READY = "add-edit-hr-tickets-ready"


const PREVIOUS_STORE_FILTER_START_DATE = "hr-tickets-previous-start-date"
const PREVIOUS_STORE_FILTER_END_DATE = "hr-tickets-previous-end-date"
const PREVIOUS_STORE_FILTER_CITY = "hr-tickets-previous-city"

const initialState = {
    isHRTicketsTableReady: true,
    isAddEditHRTicketsReady:true,
    hRTickets: {},

    previousFilterStartDate: "",
    previousFilterEndDate: "",
    previousFilterCity: "",

    
    hrTicketsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case HR_TICKETS_TABLE_READY:
            return Object.assign({}, state, { isHRTicketsTableReady: action.payload })
        case ADD_EDIT_HR_TICKETS_READY:
            return Object.assign({}, state, { isAddEditHRTicketsReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case HR_TICKETS_ID_FOR_ACTION:
            return Object.assign({}, state, {hrTicketsSelectedId:action.payload})



        case PREVIOUS_STORE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_STORE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})
        case PREVIOUS_STORE_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        default:
        return state
    
    }

}

export function hrTicketsTableReady(data) {
    return {
        type: HR_TICKETS_TABLE_READY,
        payload: data
    }
}


export function addEditHRTicketReady(data) {
    return {
        type: ADD_EDIT_HR_TICKETS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function hrTicketsIdForAction(brandId){
    return{
        type:HR_TICKETS_ID_FOR_ACTION,
        payload:brandId
    }
}


export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_END_DATE,
        payload:fiter_val
    }
}



export function previousFilterCity(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_CITY,
        payload:fiter_val
    }
}




// WEBPACK FOOTER //
// ./src/modules/HR/redux/hr.js